<template>
   <vue-good-table 
					@on-selected-rows-change="verResultado"
		  			mode="remote"
					@on-page-change="onPageChange"
					@on-sort-change="onSortChange"
  					@on-search="onSearch"
  					@on-per-page-change="onPerPageChange"
					:columns="columns" 
					:rows="rows" 
					:totalRows="totalRecords"
					:lineNumbers="true"
					:isLoading.sync="isLoading"
					:search-options="{ enabled: true, placeholder: this.placeholder }" 
					:pagination-options="{
						enabled: true, 
						position: 'bottom',
						nextLabel: 'Siguiente',
    					prevLabel: 'Anterior',
    					rowsPerPageLabel: 'Registros por página',
    					ofLabel: 'de',
    					pageLabel: 'página', // for 'pages' mode
    					allLabel: 'Todo',
					 }"
			
					:selectOptions="{
					enabled: true,
					selectOnCheckboxOnly: true,
					selectionInfoClass: 'alert alert-info m-b-0 no-rounded-corner',
					selectionText: 'filas seleccionadas',
					clearSelectionText: 'Deseleccionar',
					
					}"
				>
			<div slot="selected-row-actions" style="margin: -2px 0;">
				<button v-if="!ocultarEditar"  v-show="selectedRows.length<2" type="button" @click="editar()" class="btn btn-sm  btn-circle  btn-warning m-r-5 "> <i class="fa fa-edit"></i> Editar</button>
				<button v-if="!ocultarEliminar" class="btn btn-sm btn-circle btn-danger  " type="button" @click="eliminar()"> <i class="fa fa-trash"></i> Eliminar</button>
			</div>
			<div slot="emptystate">
    			No existen registros
  			</div>
			
			<template slot="table-row" slot-scope="props">
				
				<span v-if="props.column.field == 'imagen'">
					<img v-bind:src="props.row.image" class="rounded" width="24" style="margin: -3px" />
				</span>
				<span v-else-if="props.column.field == 'estado'">
					<estado :estado="props.row.estado"/>
      				<!-- <button :class="props.row.estado=='1' ? 'btn btn-sm  btn-info':'btn btn-sm btn-warning'">{{props.row.estado=='1' ? 'ACTIVO':'INACTIVO'}}</button> -->
   				</span>
				<span v-else-if="props.column.field == 'link'">
				 <a  :href="props.row.link"  target="_blank" class="btn btn-primary btn-sm"> <i class="fa fa-link"></i> Abrir link </a> 
   				</span>
				<span v-else-if="props.column.label == 'Detalle'">
					<router-link  :to="props.column.rutaDetalle+props.row[props.column.field]+'/'+props.row.chip_inicial+'/'+props.row.chip_final" class="btn btn-primary btn-sm"> <i class="fa fa-list"></i> Ver Detalle</router-link>

   				</span>
				<span v-else-if="props.column.label == 'Detalle Equipo'">
					<router-link  v-show="props.row.estado_venta==2" :to="props.column.rutaDetalle+props.row[props.column.field]" class="btn btn-primary btn-sm"> <i class="fa fa-list"></i> Editar Detalle</router-link>
					<router-link  v-show="props.row.estado_venta==1" :to="props.column.rutaDetalle+props.row[props.column.field]" class="btn btn-warning btn-sm"> <i class="fa fa-check"></i> Equipo Vendido</router-link>
					<router-link  v-show="props.row.estado_venta==0" :to="props.column.rutaDetalle+props.row[props.column.field]" class="btn bg-primary text-white btn-sm"> <i class="fa fa-times"></i> Equipo Anulado</router-link>
   				</span>
				<span v-else-if="props.column.label == 'Adelantos'">
					<button type="button" class="btn btn-green btn-sm btn-rounded"  @click="adelanto(props.row)"> S/. Adelantos </button>
   				</span>
				<span v-else-if="props.column.label == 'Estado General'">
							<b>V</b>({{props.row.vendido }}) - <b>A</b>({{props.row.anulado }}) - <b>N</b>({{props.row.nuevo }})
   				</span>
				<span v-else-if="props.column.label == 'Tipo Vendedor'">
					<!-- {{props.row.tipo_vendedor==1 ? 'FFVV':props.row.tipo_vendedor==2 ? 'PDV' :'SIN DEFINIR'  }} -->
					{{filtrar(props.row.tipo_vendedor) }}	

   				</span>
				   
				<span v-else>
					 <span v-if="props.column.label == 'Vendedor'">
						<span :class="props.row.estado_personal==0 ? 'bg-danger text-white p-4 rounded': ''">	 {{props.formattedRow[props.column.field]}} </span>
					</span>	
					<span v-else> 
						<!-- {{props.row.estado_personal}} -->
					 <!-- {{props.formattedRow[props.column.field]}} -->
					<span  :slot="props.column.field">
					
					<slot :name="props.column.field" v-bind:[props.column.field]="props.row">
						{{props.formattedRow[props.column.field]}}
					</slot>
				</span>



					 
					</span>	
					
				</span>
			</template>
		</vue-good-table>
</template>

<script>
import axios from 'axios'
import estado from './Estado'
export default {
    	name: "RegistrosComponent",
        props:['url','columns','field','ocultarEliminar','ocultarEditar','placeholder','departamento'],
		components:{
			estado
		},
		created(){
			this.loadItems() ;
		},
		data() {
			return {
				isLoading: false,
				selectedRows: [],
				selectedEditar:null,
				rows: [],
				totalRecords:0,
				serverParams: {
					departamento:'',
      				search:'',
     				sort: {
        				field: this.field, 
        				type: 'asc',
      				},
					page: 1, 
      				perPage: 10
    			},
			}
		},
		methods: {
			// server side 
			updateParams(newProps) {
				this.serverParams = Object.assign({}, this.serverParams, newProps);
			},

			onPageChange(params) {
				this.updateParams({
					page: params.currentPage
				});
				this.loadItems();
			},

			onPerPageChange(params) {
				
				this.updateParams({
					perPage: params.currentPerPage
				});
				this.loadItems();
			},

			onSortChange(params) {
				this.serverParams.sort={
					field: params[0].field, 
        			type: params[0].type,
				}
				this.loadItems();
			},

			onSearch(search) {
				// console.log(search.searchTerm);
				this.serverParams.search=search.searchTerm;
				// this.updateParams(params);
				this.loadItems();
			},

			// load items is what brings back the rows from server
			loadItems() {
                this.isLoading=true;
				this.serverParams.departamento=this.departamento;
				 axios.post(this.url,this.serverParams).then(response => {
					this.totalRecords = response.data[1];
					this.rows = response.data[0];
                    this.isLoading=false;
				});
			},
			verResultado(result){
				this.selectedRowsTable=[];
				// console.log(result['selectedRows'][0]);
				this.selectedEditar=result['selectedRows'][0];
				this.selectedRows=[...result['selectedRows']];
			},
			editar(){
				this.$emit("editar",this.selectedEditar)
			},
			eliminar(){
				this.$emit("eliminar",this.selectedRows)
			},
			adelanto(registro){
				this.$emit("adelanto_saldo",registro);
			},
			filtrar(tipo){
			  let nuevoTipo=this.$store.state.dataTipoVendedor.filter(elemento=>elemento.Id==tipo);

			  return nuevoTipo[0].tipo;
			}


		},

}
</script>

<style>

</style>